/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsNarrativeComparisonSchema } from "./narrativeComparisonSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsReplayNarrativePointDtoSchema = z.object({
  metricKey: z.string().nullish(),
  teamValue: z.optional(z.number()),
  opponentValue: z.optional(z.number()),
  get comparison() {
    return goodLuckCoreDTOsNarrativeComparisonSchema.optional();
  },
  ratio: z.optional(z.number()),
  topPlayerName: z.string().nullish(),
  topPlayerUserId: z.string().nullish(),
  topPlayerValue: z.optional(z.number()),
});
